<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="dicShift_list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            :searchLocal="false"
            :addButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            @Edit="Edit"
            @Delete="Delete"
        >
            <template slot="filter-after">
                <el-button type="primary" size="mini" @click="refreshList()" title="刷新当前页面">刷新<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `Shift_dic:create`) != -1" @click="Add()" title="新增"
                    >创建<i class="el-icon--right"></i
                ></el-button>
            </template>
        </crud-facecade>
        <el-dialog
            ref="form-saveas"
            class="form-table-h280"
            :title="dialogTitle"
            :visible.sync="visibleSync"
            :destroy-on-close="true"
            :before-close="handleClose"
            :close-on-click-modal="false"
            width="50%"
        >
            <el-form :model="form" :label-position="labelPosition" label-width="80px" :rules="rules" ref="form">
                <el-row>
                    <el-col :span="16">
                        <el-form-item label="班次名称" prop="name" style="text-align: left">
                            <el-input v-model="form.name" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="前景色" style="text-align: left">
                            <el-color-picker v-model="form.color"></el-color-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item label="背景色" style="text-align: left">
                            <el-color-picker v-model="form.back_color"></el-color-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                    <item-input type="table" class="table-h280" v-model="form.childShifts" :options="childShiftColumns"></item-input>
                    </el-col>
                    <!-- <el-col class="line" :span="2"></el-col> -->
                    <el-col :span="16">
                        <el-form-item label="所属区域" style="text-align: left">
                            <!-- <el-select v-model="form.dicWardIds" multiple collapse-tags placeholder="请选择">
                                <el-option v-for="item in this[`ward_auth`]" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select> -->
                            <item-input size="medium" type="multiselect" v-model="form.dicWardIds" :options="this[`ward_auth`]" :showCount="3" :collapseTags="false" placeholder="请选择"></item-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="状态" style="text-align: left" label-width="120px">
                            <el-switch v-model="form.tempStatus"></el-switch>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col class="line" :span="2"></el-col> -->

                    <el-col :span="16">
                        <el-form-item label="科室" style="text-align: left">
                            <item-input size="medium" type="multiselect" v-model="form.dicSectionIds" :options="this[`section_auth`]" :showCount="3" :collapseTags="false" placeholder="请选择"></item-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="是否关联年休假" style="text-align: left" label-width="120px">
                            <el-switch v-model="form.is_link_annual_leave"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="16">
                        <el-form-item label="所属排班" style="text-align: left;">
                            <item-input size="medium" type="multiselect" v-model="form.relScheduleShift" :options="this.dicSchedule" :showCount="3" :collapseTags="false" placeholder="请选择"></item-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="是否属于加班" style="text-align: left" label-width="120px">
                            <el-switch v-model="form.is_overtime"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="当天时间" style="text-align: left">
                            <div v-for="(option, index) in form.today" :key="option.id" style="padding-top: 6px">
                                <el-time-select
                                    placeholder="起始时间"
                                    v-model="option.beginTime"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:05',
                                        end: '24:00'
                                    }"
                                >
                                </el-time-select>
                                <el-time-select
                                    placeholder="结束时间"
                                    v-model="option.endTime"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:05',
                                        end: '24:00',
                                        minTime: option.beginTime
                                    }"
                                >
                                </el-time-select>
                                <span style="color: #f56c6c; font-size: 13px" v-if="index > 0" @click="deleteOption(option, 1)">
                                    <i class="el-icon-remove-outline" style="font-size: 13px; color: #f56c6c; width: 10px"></i>
                                    移除
                                </span>
                                <span style="color: #2629f0; font-size: 13px" v-else @click="addtoday()">
                                    <i class="el-icon-circle-plus-outline" style="font-size: 13px; color: #2629f0; width: 10px"></i>
                                    添加
                                </span>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="次日时间" style="text-align: left">
                            <div v-for="(option, index) in form.nextDay" :key="option.id" style="padding-top: 6px; width: 100%">
                                <el-time-select
                                    placeholder="起始时间"
                                    v-model="option.beginTime"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:05',
                                        end: '24:00'
                                    }"
                                >
                                </el-time-select>
                                <el-time-select
                                    placeholder="结束时间"
                                    v-model="option.endTime"
                                    :picker-options="{
                                        start: '00:00',
                                        step: '00:05',
                                        end: '24:00',
                                        minTime: option.beginTime
                                    }"
                                >
                                </el-time-select>
                                <span style="color: #f56c6c; font-size: 13px" v-if="index > 0" @click="deleteOption(option, 2)">
                                    <i class="el-icon-remove-outline" style="font-size: 13px; color: #f56c6c; width: 10px"></i>
                                    移除
                                </span>
                                <span style="color: #2629f0; font-size: 13px" v-else @click="addNextDay()">
                                    <i class="el-icon-circle-plus-outline" style="font-size: 13px; color: #2629f0; width: 10px"></i>
                                    添加
                                </span>
                            </div>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24">
                        <el-form-item label="备注"  prop="remark">
                            <el-input type="textarea" :rows="2" v-model="form.remark" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="SaveAs">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

import { mapGetters } from 'vuex'
export default {
    name: `DicShift`,
    props: {

    },
    data() {
        return {
            form: {
                id: 0,
                name: ``,
                tempStatus: true,
                status: 0,
                back_color: ``,
                color: ``,
                is_link_annual_leave: false,
                is_overtime: false,
                remark: ``,
                relScheduleShift: [],
                dicWardIds: [],
                dicSectionIds: [],
                today: [],
                nextDay: []
            },
            dicSchedule: [],
            labelPosition: `right`,
            visibleSync: false,
            dialogTitle: ``,
            title: `班次设置`,
            currentPage: 1,
            pageSize: 50,
            total: 0,
            rules: {
                name: [
                    { required: true, message: `请输入班次名称`, trigger: `blur` },
                    { min: 0, max: 50, message: `长度50个字符以内`, trigger: `blur` }
                ],
                remark: [
                    { min: 0, max: 250, message: `长度250个字符以内`, trigger: `blur` }
                ]
            },
            url: {
                baseURL: `/api/AcisSystem/DicShift`,
                get: () => {
                    return new Promise((resolve) => {
                        let req = this.myaxios.get(`/api/AcisSystem/DicShift/Get`)
                        req.then(data => {
                            console.log(data)
                            resolve(data)
                        })
                    })
                }
            },
            buttons: [],
            relation: {
                title: ``,
                visible: false,
                item: {}
            },
            childShiftColumns: [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    width: `80`,
                    isKey: true,
                    isListable: false
                },
                {
                    type: `integer`,
                    prop: `parent_id`,
                    label: `父Id`,
                    isListable: false
                },
                {
                    type: `string`,
                    prop: `name`,
                    label: `子班次名称`,
                    isListable: true,
                    isExpand: false,
                    readonly: false
                },
                {
                    type: `integer`,
                    prop: `row_counts`,
                    label: `行`,
                    readonly: false,
                    isListable: true,
                    default: 2
                },
                {
                    type: `integer`,
                    prop: `column_counts`,
                    label: `列`,
                    readonly: false,
                    isListable: true,
                    default: 2
                }
            ]
        }
    },
    created() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.initData()
    },
    computed: {
        ...mapGetters([`sysuser/workers`, `permissions`, `section_auth`, `sys_enums`, `screenHeight`, `ward_auth`, `currentUser`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            let me = this
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `number`,
                prop: `display_order`,
                label: `排序`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                readonly: false,
                sortable: true,
                isDisplayOrder: true
            }, {
                type: `string`,
                prop: `name`,
                label: `班次名称`,
                width: `180`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `bool`,
                prop: `status`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                options: [{ label: `启用`, value: 1 }, { label: `禁用`, value: 0 }],
                default: 1,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `multiselect`,
                prop: `relScheduleShift`,
                label: `所属排班`,
                width: `180`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                options: this.dicSchedule
            }, {
                type: `multiselect`,
                prop: `dicWardIds`,
                label: `所属区域`,
                width: `180`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this[`ward_auth`]
            }, {
                type: `multiselect`,
                prop: `dicSectionIds`,
                label: `科室`,
                width: `180`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                options: this[`section_auth`]
            }, {
                type: `string`,
                prop: `remark`,
                label: `备注`,
                width: `240`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: true,
                sortable: false
            }, {
                type: `string`,
                prop: `creator`,
                label: `创建人`,
                width: `120`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: true,
                isKey: false
            }, {
                type: `date`,
                prop: `create_dt`,
                label: `创建时间`,
                width: `140`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false,
                isKey: false
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `200`,
                fixed: `right`,
                isListable: true,
                readonly: false,
                options: function(that, { row }) {
                    let btns = []
                    if (me.permissions && me.permissions.findIndex(item => item.permission === `Shift_dic:edit`) != -1) {
                        btns.push({
                            class: `is-plain`,
                            label: `编辑`,
                            icon: ``,
                            type: `primary`,
                            emit: `Edit`,
                            permission: `default`
                        })
                    }
                    if (me.permissions && me.permissions.findIndex(item => item.permission === `Shift_dic:delete`) != -1) {
                        btns.push({
                            class: `is-plain`,
                            label: `删除`,
                            icon: ``,
                            type: `danger`,
                            emit: `Delete`,
                            permission: `default`
                        })
                    }
                    return btns
                }
            }]
        },
        formColumns() {
            return [{
                type: `string`,
                prop: `name`,
                label: `班次名称`,
                width: `180`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `colorpicker`,
                prop: `name`,
                label: `颜色填充`,
                width: `180`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `bool`,
                prop: `status`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                options: [{ label: `启用`, value: 1 }, { label: `禁用`, value: 0 }],
                default: 1,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `multiselect`,
                prop: `relScheduleShift`,
                label: `所属排班`,
                width: `180`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                options: this.dicSchedule
            }, {
                type: `multiselect`,
                prop: `dicWardIds`,
                label: `所属区域`,
                width: `180`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this[`ward_auth`]
            }, {
                type: `multiselect`,
                prop: `dicSectionIds`,
                label: `科室`,
                width: `180`,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                options: this[`section_auth`]
            }, {
                type: `textarea`,
                prop: `remark`,
                label: `备注`,
                width: `240`,
                colspan: 24,
                config: {
                    minRows: 3
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }]
        }
    },
    mounted() {
    },
    methods: {
        cancel() {
            this.visibleSync = false
            this.$refs[`form`].resetFields()
        },
        handleClose(done) {
            this.$refs[`form`].resetFields()
            done()
        },
        deleteOption(item, type) {
            if (type == 1) {
                this.form.today = this.form.today.filter((e) => e.id != item.id)
            } else if (type == 2) {
                this.form.nextDay = this.form.nextDay.filter((e) => e.id != item.id)
            }
        },
        // 当天加一行
        addtoday() {
            var count = this.form.today.length + 1
            this.form.today.push({
                id: count,
                beginTime: ``,
                endTime: ``,
                type: 1,
                typeName: `当日`
            })
        },
        addNextDay() {
            var count = this.form.nextDay.length + 1
            this.form.nextDay.push({
                id: count,
                beginTime: ``,
                endTime: ``,
                type: 2,
                typeName: `次日`
            })
        },
        SaveAs() {
            var that = this
            that.$refs.form.validate(valid => {
                console.log(valid)
                if (valid) {
                    if (that.form.id > 0) {
                        that.form.row_counts = that.form.row_counts || 2
                        that.form.column_counts = that.form.column_counts || 2
                        that.form.status = that.form.tempStatus == true ? 1 : 0
                        that.form.back_color = that.form.back_color == null ? `` : that.form.back_color
                        that.form.color = that.form.color == null ? `` : that.form.color
                        that.form.childShifts = _.map(that.form.childShifts, d => {
                            d.parent_id = that.form.id
                            return d
                        })
                        return new Promise((resolve) => {
                            let req = that.myaxios.put(`/api/AcisSystem/DicShift/Put`, that.form)
                            req.then(data => {
                                // 提示保存成功，刷新列表
                                that.$message.success(`修改成功`)
                                this.$refs[`form`].resetFields()
                                that.visibleSync = false
                                that.refreshList()
                                resolve(data)
                            }).catch(e => {
                                console.log(e)
                            })
                        })
                    } else {
                        that.form.row_counts = that.form.row_counts || 2
                        that.form.column_counts = that.form.column_counts || 2
                        that.form.status = that.form.tempStatus == true ? 1 : 0
                        return new Promise((resolve) => {
                            let req = that.myaxios.post(`/api/AcisSystem/DicShift/Post`, that.form)
                            req.then(data => {
                                // 提示保存成功，刷新列表
                                that.$message.success(`添加成功`)
                                this.$refs[`form`].resetFields()
                                that.visibleSync = false
                                that.refreshList()
                                resolve(data)
                            }).catch(e => {
                                console.log(e)
                            })
                        })
                    }
                }
            })
        },
        confirmForm() {
        },
        Edit(row) {
            var that = this
            return new Promise((resolve) => {
                let req = that.myaxios.get(`/api/AcisSystem/DicShift/Get`, { id: row.row.id })
                req.then(data => {
                    if (data) {
                        data.tempStatus = data.status == 1
                        that.form = data
                        that.dialogTitle = `修改`
                        if (data.today == null || data.today.length == 0) {
                            that.form.today = [{
                                id: 1,
                                beginTime: ``,
                                endTime: ``,
                                type: 1,
                                typeName: `当日`
                            }]
                        }
                        if (data.nextDay == null || data.nextDay.length == 0) {
                            this.form.nextDay = [{
                                id: 1,
                                beginTime: ``,
                                endTime: ``,
                                type: 2,
                                typeName: `次日`
                            }]
                        }
                        that.visibleSync = true
                        resolve(data)
                    }
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        Delete(row) {
            var that = this
            return new Promise((resolve) => {
                let req = that.myaxios.delete(`/api/AcisSystem/DicShift/Delete?id=${row && row.row.id}`)
                req.then(data => {
                    that.$message.success(`删除成功`)
                    that.refreshList()
                    resolve(data)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        Add() {
            this.dialogTitle = `新增`
            this.form = {
                id: 0,
                name: ``,
                tempStatus: true,
                status: 0,
                back_color: ``,
                color: ``,
                is_link_annual_leave: false,
                is_overtime: false,
                remark: ``,
                relScheduleShift: [],
                dicWardIds: [],
                dicSectionIds: [],
                childShifts: [],
                today: [],
                nextDay: []
            }
            this.form.today = [{
                id: 1,
                beginTime: ``,
                endTime: ``,
                type: 1,
                typeName: `当日`
            }]
            this.form.nextDay = [{
                id: 1,
                beginTime: ``,
                endTime: ``,
                type: 2,
                typeName: `次日`
            }]
            this.visibleSync = true
        },
        initData() {
            return new Promise((resolve, reject) => {
                let req1 = this.myaxios.get(`/api/AcisSystem/SysUser/Get`)
                let req2 = this.myaxios.get(`/api/AcisSystem/DicSchedule/Get`)
                this.myaxios
                    .all(req1, req2)
                    .then(([data1, data2]) => {
                        this.users = _.map(data1, d => {
                            return {
                                value: d.id,
                                label: d.dic_worker_name || `--`,
                                disabled: d.is_deleted,
                                code: `${d.dic_worker_worker_duty || `--`}|${d.dic_worker_surgery_scale || `--`}|${d.dic_worker_section_name || `--`}`
                            }
                        })
                        this.dicSchedule = _.map(data2, d => {
                            return {
                                value: d.id,
                                label: d.name || `--`,
                                disabled: !d.status_b
                            }
                        })
                    })
                    .catch(e => {
                        console.log(e)
                        reject(e)
                    })
            })
        },
        refreshList() {
            this.$refs[`dicShift_list`].ReloadListData()
        },
        reloadListData() {
            this.$refs[`dicShift_list`].ReloadListData()
        }

    }
}
</script>
<style lang="less" scoped>
.theme-dark .el-date-editor.el-input,
.theme-dark .el-date-editor.el-input__inner,
.theme-his-blue .el-date-editor.el-input,
.theme-his-blue .el-date-editor.el-input__inner {
    width: 46% !important;
}
.el-select {
    display: block !important;
}
.el-form-item {
    margin-bottom: 10px;
}
.el-form-item.left {
    .el-form-item__label {
        width: 70px;
    }
    .el-form-item__content {
        margin-left: 70px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Schedule/DicShift.vue